import React from "react"
import { INLINES } from "@contentful/rich-text-types"

import { Link, RichText } from "components"

function CareersCallToAction({ ...data }) {
  return (
    <>
      {data.careersCta && (
        <section
          data-component="CareersCallToAction"
          id="careers-call-to-action"
          className="relative py-10 wrapper md:py-30 default-grid"
        >
          <div className="space-y-8 text-center xl:col-span-6 col-span-full lg:col-span-8 lg:col-start-3 xl:col-start-4">
            {data.careersCta && (
              <RichText
                className="space-y-6"
                content={data.careersCta}
                size="large"
                options={{
                  renderNode: {
                    [INLINES.HYPERLINK]: (node, children, uri) => (
                      <span className="inline-block pb-6 last:pb-0">
                        <Link
                          className="transition-colors duration-200 ease-out text-link text-mineralGray focus:text-violet hover:text-violet"
                          href={node.data.uri}
                        >
                          {children}
                        </Link>
                      </span>
                    ),
                  },
                }}
              />
            )}
          </div>
        </section>
      )}
    </>
  )
}

export default CareersCallToAction
